import Stack from '@mui/material/Stack'
import { IFindJobsJobItem } from '../../../types/findJobsType'
import JobCard from './JobCard'
import JobCardSkeleton from './JobCardSkeleton'
import EmptyContent from '../../Common/EmptyContent/EmptyContent'

type Props = {
  items: IFindJobsJobItem[] | undefined
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  isFetching: boolean
}

const Content: React.FC<Props> = ({ items, setIsModalOpen, isFetching }) => {
  if (isFetching) {
    return (
      <Stack spacing={3.75}>
        {Array.from(Array(7).keys()).map((_, index) => (
          <JobCardSkeleton key={index} />
        ))}
      </Stack>
    )
  }

  if (!items?.length) {
    return (
      <EmptyContent
        containerProps={{
          sx: {
            marginTop: '30px',
          },
        }}
      />
    )
  }

  return (
    <>
      <Stack spacing={3.75}>
        {items?.map(item => (
          <JobCard
            job={item}
            key={item.job_id}
            setIsModalOpen={setIsModalOpen}
          />
        ))}
      </Stack>
    </>
  )
}

export default Content
